import {
  typographyStyles,
  TTypography,
  BREAKPOINTS,
} from 'common/styles';
import styled, { css } from 'styled-components';

interface IMOText {
  typographyStyle?: TTypography
  center?: boolean,
  fontColor?: string,
  as?: React.ElementType
}

const MOText = styled.span<IMOText>`
  ${({ center }) => center && css`text-align: center;`}

  ${({ fontColor }) => fontColor && css`color: ${fontColor || ''} !important;`}

  ${({ typographyStyle }) => typographyStyles[typographyStyle || 'body1']}

  ${({ typographyStyle }) => {
    if (typographyStyle === 'heading2') {
      return css`
          @media only screen and (max-width: ${BREAKPOINTS.SMALL}px) {
            ${typographyStyles.heading3}
          }
      `;
    }
  }}

  ${({ typographyStyle }) => {
    if (typographyStyle === 'heading1') {
      return css`
          @media only screen and (max-width: ${BREAKPOINTS.SMALL}px) {
            ${typographyStyles.heading2}
          }
      `;
    }
  }}
`;

export default MOText;
